<template>
	<div class="component-overview">
		<!-- 标题区 -->
		<section class="hero">
			<!-- 返回按钮已移至顶部菜单，避免被 .topinfo 遮挡 -->
		<!--	<h1>能力中心 · 组件总览</h1>
			<div class="sub">CAPABILITY CENTER · COMPONENT OVERVIEW</div>
			<div class="deco">
				<div class="line"></div>
				<div class="diamond"></div>
				<div class="line r"></div>
			</div>-->
		</section>

		<!-- 统计概览条 -->
		<section class="stats-bar">
			<div class="stat-item" v-for="(s, i) in statList" :key="i">
				<div class="icon">{{ s.icon }}</div>
				<div class="num">{{ s.num }}<span class="unit">{{ s.unit }}</span></div>
				<div class="label">{{ s.label }}</div>
				<div class="trend">{{ s.trend }}</div>
			</div>
		</section>

		<!-- 主区 -->
		<main class="main">
			<div class="main-left">
				<!-- 工具栏 -->
				<div class="toolbar">
					<div class="filter-tabs">
						<div class="ftab" :class="{ active: currentCat === c.key }" v-for="c in categories" :key="c.key"
							@click="setCat(c.key)">{{ c.name }}({{ c.count != null ? c.count : catCount(c.key) }})</div>
					</div>
					<div class="search-box">
						<span class="sicon">🔍</span>
						<input type="text" v-model.trim="keyword" placeholder="搜索能力组件名称..." />
					</div>
				</div>
				<!-- 卡片网格 -->
				<div class="grid" v-if="filteredList.length">
					<div class="card" v-for="c in filteredList" :key="c.id" @click="openModal(c)">
						<div class="head">
							<div class="cicon">{{ c.icon }}</div>
							<span class="status-tag" :class="c.status">{{ statusText(c.status) }}</span>
						</div>
						<h3>{{ c.name }}</h3>
						<div class="desc">{{ c.desc }}</div>
						<div class="metrics">
							<div class="m">
								<div class="v">{{ c.calls.toLocaleString() }}</div>
								<div class="l">今日调用</div>
							</div>
							<div class="m">
								<div class="v green">{{ c.status === 'soon' ? '--' : c.avail + '%' }}</div>
								<div class="l">可用率</div>
							</div>
							<div class="m">
								<div class="v">{{ c.orgs }}</div>
								<div class="l">服务企业</div>
							</div>
						</div>
						<div class="mini-chart" :ref="'mini_' + c.id"></div>
					</div>
				</div>
				<div class="grid-empty" v-else>未找到匹配的能力组件</div>
			</div>

			<!-- 右侧栏 -->
			<aside class="side">
				<div class="panel">
					<div class="panel-title">调用次数排行 <span class="more" @click="rankModalVisible = true">更多 &gt;</span></div>
					<ul class="rank-list">
						<li v-for="(c, i) in rankList" :key="c.id">
							<span class="rank-num" :class="i < 3 ? 'r' + (i + 1) : 'rx'">{{ i + 1 }}</span>
							<span class="rank-name">{{ c.name }}</span>
							<span class="rank-val">{{ c.calls.toLocaleString() }}</span>
						</li>
					</ul>
				</div>
				<div class="panel">
					<div class="panel-title">组件分类分布</div>
					<div class="pie-chart" ref="pieChart"></div>
				</div>
				<div class="panel">
					<div class="panel-title">今日调用趋势</div>
					<div class="trend-chart" ref="trendChart"></div>
				</div>
			</aside>
		</main>

		<!-- 详情模态框 -->
		<div class="modal-mask" v-if="current" @click.self="closeModal">
			<div class="modal">
				<div class="modal-head">
					<div class="left">
						<div class="cicon">{{ current.icon }}</div>
						<div>
							<h2>{{ current.name }}</h2>
							<div class="cat">分类：{{ current.categoryName }} · 版本：{{ current.version }} · 状态：{{ current.statusText }}</div>
						</div>
					</div>
					<div class="modal-close" @click="closeModal">✕</div>
				</div>
				<div class="modal-desc">{{ current.description }}</div>
				<div class="modal-grid">
					<div class="mstat" v-for="(m, i) in current.metrics" :key="i">
						<div class="v">{{ fmtMetric(m) }}</div>
						<div class="l">{{ m.label }}</div>
					</div>
				</div>
				<div class="modal-section" v-if="current.trend && current.trend.values && current.trend.values.length">
					<h4>近7日调用趋势</h4>
					<div class="modal-chart" ref="modalChart"></div>
				</div>
				<div class="modal-section">
					<h4>核心接口列表</h4>
					<table class="api-table">
						<thead>
							<tr>
								<th style="width: 70px">方法</th>
								<th>接口路径</th>
								<th>说明</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(a, i) in current.apis" :key="i">
								<td><span class="method" :class="a.m">{{ a.m }}</span></td>
								<td class="api-path">{{ a.p }}</td>
								<td>{{ a.d }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<!-- 完整排行弹窗 -->
		<div class="modal-mask" v-if="rankModalVisible" @click.self="rankModalVisible = false">
			<div class="modal rank-modal">
				<div class="modal-head rank-head">
					<h2>调用次数排行</h2>
					<div class="modal-close" @click="rankModalVisible = false">✕</div>
				</div>
				<ul class="rank-list rank-full">
					<li v-for="(c, i) in rankAllList" :key="c.id">
						<span class="rank-num" :class="i < 3 ? 'r' + (i + 1) : 'rx'">{{ i + 1 }}</span>
						<span class="rank-name">{{ c.name }}</span>
						<span class="rank-val">{{ formatNum(c.calls) }}</span>
					</li>
					<li class="rank-empty" v-if="!rankAllList.length">暂无排行数据</li>
				</ul>
			</div>
		</div>

		<!-- Toast -->
		<div class="page-toast" :class="{ show: toastVisible }">{{ toastText }}</div>
	</div>
</template>

<script>
import * as echarts from 'echarts'

export default {
	name: 'ComponentOverview',
	data() {
		return {
			currentCat: 'all',
			keyword: '',
			current: null,
			rankModalVisible: false,
			toastText: '',
			toastVisible: false,
			toastTimer: null,
			miniCharts: {},
			pieChartInst: null,
			trendChartInst: null,
			modalChartInst: null,
			// 接口数据（异常时保留下方演示数据兜底）
			statIcons: ['🧩', '⚡', '🏢', '📡', '💚', '🔐'],
			stats: null,
			distribution: null,
			callTrend: {
				unit: '次',
				labels: ['00', '04', '08', '12', '16', '20', '24'],
				values: [1200, 800, 3200, 5600, 6800, 5400, 2800],
			},
			categories: [
				{ key: 'all', name: '全部组件' },
				{ key: 'standard', name: '标准规范' },
				{ key: 'supply', name: '供应链流通' },
				{ key: 'data', name: '数据智能' },
				{ key: 'service', name: '服务生态' },
				{ key: 'safety', name: '安全监管' },
				{ key: 'agri', name: '生产种植' },
			],
			components: [
				{ id: 1, name: '准入标准能力组件', icon: '📋', cat: 'standard', status: 'running',
					desc: '市场主体准入审核、资质证照核验、准入规则配置与黑白名单管理，实现全行业准入一把尺。',
					calls: 3210, avail: 99.85, orgs: 1286, version: 'v2.4.1',
					trend: [220, 280, 310, 290, 350, 420, 380],
					apis: [
						{ m: 'POST', p: '/api/v2/admission/check', d: '主体准入核验' },
						{ m: 'GET', p: '/api/v2/admission/qual/{id}', d: '资质证照查询' },
						{ m: 'POST', p: '/api/v2/admission/blacklist', d: '黑白名单管理' },
						{ m: 'GET', p: '/api/v2/admission/rules', d: '准入规则列表' },
					] },
				{ id: 2, name: '食材标准能力组件', icon: '📚', cat: 'standard', status: 'running',
					desc: '食材品类标准库、品质分级标准、检验检测标准、地方特色食材标准管理与查询服务。',
					calls: 2756, avail: 99.91, orgs: 968, version: 'v2.3.0',
					trend: [180, 220, 260, 240, 280, 310, 290],
					apis: [
						{ m: 'GET', p: '/api/v2/food-standard/category', d: '食材品类查询' },
						{ m: 'GET', p: '/api/v2/food-standard/grade/{code}', d: '品质分级标准' },
						{ m: 'GET', p: '/api/v2/food-standard/test/{id}', d: '检验标准明细' },
					] },
				{ id: 3, name: '食材供应链能力组件', icon: '🔗', cat: 'supply', status: 'running',
					desc: '上下游链路可视化、供应商档案管理、供货周期评估、供应链协同与订单追踪。',
					calls: 1980, avail: 99.66, orgs: 742, version: 'v3.1.2',
					trend: [150, 180, 210, 190, 230, 260, 240],
					apis: [
						{ m: 'GET', p: '/api/v2/supply/chain/{orgId}', d: '供应链链路查询' },
						{ m: 'POST', p: '/api/v2/supply/supplier', d: '供应商档案创建' },
						{ m: 'GET', p: '/api/v2/supply/order/track', d: '订单在途追踪' },
					] },
				{ id: 4, name: '人才培育能力组件', icon: '🎓', cat: 'service', status: 'running',
					desc: '火锅产业人才培训课程体系、技能等级认定、农技人才库、师徒传承与人才流动监测。',
					calls: 876, avail: 99.70, orgs: 356, version: 'v1.8.5',
					trend: [60, 80, 90, 85, 100, 110, 95],
					apis: [
						{ m: 'GET', p: '/api/v2/talent/course/list', d: '培训课程列表' },
						{ m: 'POST', p: '/api/v2/talent/cert/audit', d: '技能等级认定' },
						{ m: 'GET', p: '/api/v2/talent/profile/{id}', d: '人才档案查询' },
					] },
				{ id: 5, name: '消费者服务能力组件', icon: '🎧', cat: 'service', status: 'running',
					desc: 'C端消费者咨询投诉受理、售后维权、消费权益保障、评价反馈与满意度分析。',
					calls: 1542, avail: 99.80, orgs: 523, version: 'v2.0.8',
					trend: [120, 140, 160, 150, 180, 200, 190],
					apis: [
						{ m: 'POST', p: '/api/v2/consumer/complaint', d: '投诉受理' },
						{ m: 'GET', p: '/api/v2/consumer/feedback/{id}', d: '反馈查询' },
						{ m: 'GET', p: '/api/v2/consumer/satisfaction', d: '满意度统计' },
					] },
				{ id: 6, name: '数据分析能力组件', icon: '📊', cat: 'data', status: 'running',
					desc: '产业数据清洗治理、多维统计分析、自定义报表生成、数据接口开放与数据资产目录。',
					calls: 3890, avail: 99.93, orgs: 1520, version: 'v4.0.0',
					trend: [300, 350, 400, 380, 450, 520, 480],
					apis: [
						{ m: 'POST', p: '/api/v2/data/query', d: '多维数据查询' },
						{ m: 'GET', p: '/api/v2/data/report/list', d: '报表目录' },
						{ m: 'POST', p: '/api/v2/data/export', d: '数据导出任务' },
					] },
				{ id: 7, name: '决策支持能力组件', icon: '🎯', cat: 'data', status: 'gray',
					desc: '产业运行态势推演、政策效果模拟、风险预警评估、辅助决策方案生成与对比分析。',
					calls: 643, avail: 99.51, orgs: 128, version: 'v1.2.0-beta',
					trend: [40, 50, 60, 55, 70, 80, 75],
					apis: [
						{ m: 'POST', p: '/api/v2/decision/simulate', d: '政策效果模拟' },
						{ m: 'GET', p: '/api/v2/decision/risk', d: '风险预警列表' },
					] },
				{ id: 8, name: '金融服务能力组件', icon: '💳', cat: 'service', status: 'running',
					desc: '供应链金融对接、企业授信评估、在线结算对账、保险服务接入与融资撮合。',
					calls: 954, avail: 99.77, orgs: 418, version: 'v2.1.3',
					trend: [70, 90, 100, 95, 110, 130, 120],
					apis: [
						{ m: 'POST', p: '/api/v2/finance/credit/apply', d: '授信申请' },
						{ m: 'GET', p: '/api/v2/finance/settle/{id}', d: '结算对账查询' },
						{ m: 'POST', p: '/api/v2/finance/insurance', d: '保险投保' },
					] },
				{ id: 9, name: '品牌推广能力组件', icon: '📣', cat: 'service', status: 'running',
					desc: '区域公用品牌管理、品牌档案库、营销素材中心、曝光传播监测与品牌价值评估。',
					calls: 721, avail: 99.62, orgs: 289, version: 'v1.5.2',
					trend: [50, 65, 75, 70, 85, 95, 88],
					apis: [
						{ m: 'GET', p: '/api/v2/brand/list', d: '品牌档案列表' },
						{ m: 'POST', p: '/api/v2/brand/material', d: '营销素材上传' },
						{ m: 'GET', p: '/api/v2/brand/exposure', d: '曝光数据统计' },
					] },
				{ id: 10, name: '产业协同能力组件', icon: '🤝', cat: 'service', status: 'running',
					desc: '跨主体协同任务管理、联合项目管理、产业联盟协作、信息共享与会议协同。',
					calls: 1145, avail: 99.74, orgs: 467, version: 'v2.0.1',
					trend: [90, 110, 125, 115, 140, 160, 150],
					apis: [
						{ m: 'POST', p: '/api/v2/collab/task', d: '协同任务创建' },
						{ m: 'GET', p: '/api/v2/collab/project/{id}', d: '项目详情' },
						{ m: 'POST', p: '/api/v2/collab/share', d: '信息共享发布' },
					] },
				{ id: 11, name: '供需匹配能力组件', icon: '⇄', cat: 'supply', status: 'running',
					desc: '供给需求信息发布、智能撮合匹配、交易大厅、询价竞价与成交跟踪。',
					calls: 2166, avail: 99.82, orgs: 892, version: 'v3.0.5',
					trend: [170, 200, 230, 210, 260, 300, 280],
					apis: [
						{ m: 'POST', p: '/api/v2/match/supply', d: '供给发布' },
						{ m: 'POST', p: '/api/v2/match/demand', d: '需求发布' },
						{ m: 'GET', p: '/api/v2/match/recommend', d: '智能匹配推荐' },
					] },
				{ id: 12, name: '智控农业能力组件', icon: '🌱', cat: 'agri', status: 'running',
					desc: '种植基地物联网设备接入、环境监测、智能灌溉施肥、长势监测与精准管控。',
					calls: 1733, avail: 99.45, orgs: 234, version: 'v2.2.0',
					trend: [130, 160, 180, 170, 200, 230, 215],
					apis: [
						{ m: 'GET', p: '/api/v2/agri/device/{id}', d: '设备状态查询' },
						{ m: 'GET', p: '/api/v2/agri/env/{baseId}', d: '环境监测数据' },
						{ m: 'POST', p: '/api/v2/agri/control', d: '远程管控指令' },
					] },
				{ id: 13, name: '政企业服务能力组件', icon: '🏛️', cat: 'service', status: 'running',
					desc: '政策直达推送、政企对接服务、项目申报服务、诉求响应与政务服务集成。',
					calls: 589, avail: 99.68, orgs: 345, version: 'v1.9.0',
					trend: [45, 55, 65, 60, 75, 85, 78],
					apis: [
						{ m: 'GET', p: '/api/v2/gov/policy/list', d: '政策列表' },
						{ m: 'POST', p: '/api/v2/gov/apply', d: '项目申报' },
						{ m: 'POST', p: '/api/v2/gov/appeal', d: '企业诉求提交' },
					] },
				{ id: 14, name: '食品安全能力组件', icon: '🛡️', cat: 'safety', status: 'running',
					desc: '食品安全抽检记录、风险分级预警、合规检查、问题食品追溯与应急处置。',
					calls: 2410, avail: 99.88, orgs: 1105, version: 'v3.2.0',
					trend: [190, 220, 250, 230, 280, 320, 300],
					apis: [
						{ m: 'GET', p: '/api/v2/safety/inspection', d: '抽检记录查询' },
						{ m: 'GET', p: '/api/v2/safety/risk', d: '风险预警列表' },
						{ m: 'POST', p: '/api/v2/safety/emergency', d: '应急处置上报' },
					] },
				{ id: 15, name: '生成溯源能力组件', icon: '🔱', cat: 'safety', status: 'running',
					desc: '一物一码溯源生成、全链路溯源档案、扫码溯源查询、溯源数据上链存证。',
					calls: 3108, avail: 99.90, orgs: 1340, version: 'v4.1.2',
					trend: [250, 290, 330, 310, 370, 420, 390],
					apis: [
						{ m: 'POST', p: '/api/v2/trace/qrcode', d: '溯源码生成' },
						{ m: 'GET', p: '/api/v2/trace/chain/{code}', d: '溯源链路查询' },
						{ m: 'POST', p: '/api/v2/trace/blockchain', d: '上链存证' },
					] },
				{ id: 16, name: '物流配送能力组件', icon: '🚚', cat: 'supply', status: 'running',
					desc: '冷链物流监控、配送路线优化、在途追踪、温控报警、仓储管理与运力调度。',
					calls: 2276, avail: 99.71, orgs: 678, version: 'v2.5.0',
					trend: [180, 210, 240, 220, 270, 310, 290],
					apis: [
						{ m: 'GET', p: '/api/v2/logistics/track/{no}', d: '物流轨迹查询' },
						{ m: 'GET', p: '/api/v2/logistics/temp/{id}', d: '冷链温度监控' },
						{ m: 'POST', p: '/api/v2/logistics/dispatch', d: '运力调度' },
					] },
				{ id: 17, name: '市场分析能力组件', icon: '📈', cat: 'data', status: 'running',
					desc: '食材行情采集、价格监测预警、市场供需画像、竞品分析与区域市场对比。',
					calls: 1420, avail: 99.75, orgs: 567, version: 'v2.3.5',
					trend: [110, 130, 150, 140, 170, 190, 175],
					apis: [
						{ m: 'GET', p: '/api/v2/market/price', d: '价格行情查询' },
						{ m: 'GET', p: '/api/v2/market/supply-demand', d: '供需画像' },
						{ m: 'GET', p: '/api/v2/market/compare', d: '区域市场对比' },
					] },
				{ id: 18, name: '产业预测能力组件', icon: '🧠', cat: 'data', status: 'soon',
					desc: '产量预测、价格走势预测、消费趋势推演、产业规模预测与情景模拟分析。',
					calls: 0, avail: 0, orgs: 0, version: 'v0.9.0-dev',
					trend: [0, 0, 0, 0, 0, 0, 0],
					apis: [
						{ m: 'POST', p: '/api/v2/predict/price', d: '价格预测（内测）' },
						{ m: 'POST', p: '/api/v2/predict/output', d: '产量预测（内测）' },
					] },
			],
		}
	},
	computed: {
		statList() {
			// 接口返回的 stats 已是成品值（value/unit/note），直接展示
			if (this.stats && this.stats.length) {
				return this.stats.map((s, i) => ({
					icon: this.statIcons[i] || '📊',
					num: this.formatNum(s.value),
					unit: s.unit,
					label: s.label,
					trend: s.note,
				}))
			}
			const running = this.components.filter(c => c.status === 'running').length
			const gray = this.components.filter(c => c.status === 'gray').length
			const soon = this.components.filter(c => c.status === 'soon').length
			const totalCalls = this.components.reduce((s, c) => s + c.calls, 0)
			const totalOrgs = this.components.reduce((s, c) => s + c.orgs, 0)
			const totalApis = this.components.reduce((s, c) => s + (c.apiCount != null ? c.apiCount : (c.apis || []).length), 0)
			const availList = this.components.filter(c => c.status !== 'soon')
			const avgAvail = (availList.reduce((s, c) => s + c.avail, 0) / availList.length).toFixed(2)
			return [
				{ icon: '🧩', num: this.components.length, unit: '个', label: '能力组件总数', trend: '运行中 ' + running + ' · 灰度 ' + gray + ' · 待上线 ' + soon },
				{ icon: '⚡', num: totalCalls.toLocaleString(), unit: '次', label: '今日API调用总量', trend: '较昨日 +12.6%' },
				{ icon: '🏢', num: totalOrgs.toLocaleString(), unit: '家', label: '累计服务主体', trend: '较上月 +3.2%' },
				{ icon: '📡', num: totalApis, unit: '个', label: '开放接口总数', trend: '本月新增 8 个' },
				{ icon: '💚', num: avgAvail, unit: '%', label: '平均服务可用率', trend: 'SLA 达标率 100%' },
				{ icon: '🔐', num: 128, unit: '个', label: '已接入应用系统', trend: '政务 36 · 企业 92' },
			]
		},
		filteredList() {
			return this.components.filter(c => {
				if (this.currentCat !== 'all' && c.cat !== this.currentCat) return false
				if (this.keyword && c.name.indexOf(this.keyword) === -1 && c.desc.indexOf(this.keyword) === -1) return false
				return true
			})
		},
		rankList() {
			return [...this.components].filter(c => c.calls > 0).sort((a, b) => b.calls - a.calls).slice(0, 6)
		},
		// 「更多」弹窗展示全部组件排行
		rankAllList() {
			return [...this.components].sort((a, b) => b.calls - a.calls)
		},
	},
	watch: {
		filteredList() {
			this.$nextTick(this.renderMinis)
		}
	},
	created() {
		this.fetchOverview()
	},
	mounted() {
		this.$nextTick(() => {
			this.renderMinis()
			this.renderPie()
			this.renderTrend()
		})
		window.addEventListener('resize', this.resizeCharts)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizeCharts)
		if (this.toastTimer) clearTimeout(this.toastTimer)
		this.disposeMinis()
		if (this.pieChartInst) this.pieChartInst.dispose()
		if (this.trendChartInst) this.trendChartInst.dispose()
		if (this.modalChartInst) this.modalChartInst.dispose()
	},
	methods: {
		goBack() {
			this.$router.push({
				name: 'AbilityCenter',
				query: this.$route.query
			})
		},
		setCat(k) {
			this.currentCat = k
		},
		catCount(k) {
			if (k === 'all') return this.components.length
			return this.components.filter(c => c.cat === k).length
		},
		catName(k) {
			const c = this.categories.find(x => x.key === k)
			return c ? c.name : ''
		},
		statusText(status) {
			return { running: '运行中', gray: '灰度上线', soon: '待上线' }[status] || ''
		},
		formatNum(v) {
			return typeof v === 'number' ? v.toLocaleString() : v
		},
		fmtMetric(m) {
			if (m.value === null || m.value === undefined) return '--'
			return this.formatNum(m.value) + (m.unit || '')
		},
		// 接口示例中 trend/labels/values 是字符串化数组，统一解析
		parseList(v) {
			if (Array.isArray(v)) return v
			if (typeof v === 'string') {
				try {
					const r = JSON.parse(v)
					return Array.isArray(r) ? r : []
				} catch (e) {
					return []
				}
			}
			return []
		},
		// 组件总览主数据：stats/categories/distribution/components/callTrend 一接口全返
		fetchOverview() {
			this.$request2('/admin-api/statistics/brain/component/overview').then(res => {
				const value = res && res.code === 0 && res.data ? res.data.value : null
				if (!value) {
					console.warn('组件总览接口数据异常，沿用前端演示数据', res && res.msg)
					return
				}
				if (Array.isArray(value.stats) && value.stats.length) this.stats = value.stats
				if (Array.isArray(value.categories) && value.categories.length) {
					this.categories = value.categories.map(c => ({ key: c.code, name: c.name, count: c.count }))
					if (!this.categories.some(c => c.key === this.currentCat)) this.currentCat = 'all'
				}
				if (Array.isArray(value.distribution) && value.distribution.length) this.distribution = value.distribution
				if (Array.isArray(value.components) && value.components.length) this.components = this.mapApiComponents(value.components)
				if (value.callTrend) {
					const labels = this.parseList(value.callTrend.labels)
					const values = this.parseList(value.callTrend.values)
					if (labels.length && values.length) {
						this.callTrend = { unit: value.callTrend.unit || '次', labels, values }
					}
				}
				this.$nextTick(() => {
					this.renderPie()
					this.renderTrend()
				})
			}).catch(e => {
				console.warn('组件总览接口请求失败，沿用前端演示数据', e)
			})
		},
		// 接口组件字段映射为页面内部结构；status 0/1/2 对应 运行中/灰度/待上线
		mapApiComponents(list) {
			const statusMap = { 0: 'running', 1: 'gray', 2: 'soon' }
			return list.map((c, i) => ({
				id: c.code || i,
				code: c.code,
				name: c.name,
				icon: c.icon,
				cat: c.categoryCode,
				status: statusMap[c.status] || 'running',
				desc: c.description || '',
				version: c.version,
				calls: c.todayCalls || 0,
				avail: c.availRate,
				orgs: c.servedOrgs || 0,
				apiCount: c.apiCount || 0,
				trend: this.parseList(c.trend),
			}))
		},
		showToast(msg) {
			this.toastText = msg
			this.toastVisible = true
			if (this.toastTimer) clearTimeout(this.toastTimer)
			this.toastTimer = setTimeout(() => {
				this.toastVisible = false
			}, 1800)
		},
		disposeMinis() {
			Object.keys(this.miniCharts).forEach(key => {
				if (this.miniCharts[key]) this.miniCharts[key].dispose()
			})
			this.miniCharts = {}
		},
		renderMinis() {
			this.disposeMinis()
			this.filteredList.forEach(c => {
				if (c.status === 'soon') return
				const refArr = this.$refs['mini_' + c.id]
				const el = refArr && refArr[0]
				if (!el) return
				const ch = echarts.init(el)
				this.miniCharts[c.id] = ch
				ch.setOption({
					animation: false,
					grid: { left: 0, right: 0, top: 2, bottom: 2 },
					xAxis: { type: 'category', show: false, data: ['一', '二', '三', '四', '五', '六', '日'] },
					yAxis: { type: 'value', show: false },
					series: [{
						type: 'line',
						data: c.trend,
						smooth: true,
						symbol: 'none',
						lineStyle: { color: '#00d4ff', width: 1.5 },
						areaStyle: {
							color: {
								type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
								colorStops: [
									{ offset: 0, color: 'rgba(0,212,255,0.35)' },
									{ offset: 1, color: 'rgba(0,212,255,0)' },
								]
							}
						}
					}]
				})
			})
		},
		renderPie() {
			const el = this.$refs.pieChart
			if (!el) return
			if (this.pieChartInst) {
				this.pieChartInst.dispose()
				this.pieChartInst = null
			}
			// 优先用接口 distribution，缺失时按组件列表自行统计
			let data = []
			if (this.distribution && this.distribution.length) {
				data = this.distribution.map(d => ({ name: d.categoryName, value: d.count }))
			} else {
				const catMap = {}
				this.categories.forEach(c => { if (c.key !== 'all') catMap[c.name] = 0 })
				this.components.forEach(c => { catMap[this.catName(c.cat)]++ })
				data = Object.entries(catMap).map(([n, v]) => ({ name: n, value: v }))
			}
			this.pieChartInst = echarts.init(el)
			this.pieChartInst.setOption({
				tooltip: { trigger: 'item', textStyle: { fontSize: 12 } },
				series: [{
					type: 'pie', radius: ['45%', '70%'], center: ['50%', '50%'],
					label: { color: '#7fa8d9', fontSize: 11 },
					itemStyle: { borderColor: '#061226', borderWidth: 2 },
					data: data,
					color: ['#00d4ff', '#165DFF', '#b388ff', '#00ff9d', '#ffb020', '#ff4d6a']
				}]
			})
		},
		renderTrend() {
			const el = this.$refs.trendChart
			if (!el) return
			if (this.trendChartInst) {
				this.trendChartInst.dispose()
				this.trendChartInst = null
			}
			this.trendChartInst = echarts.init(el)
			this.trendChartInst.setOption({
				grid: { left: 30, right: 10, top: 15, bottom: 20 },
				tooltip: { trigger: 'axis', textStyle: { fontSize: 12 } },
				xAxis: {
					type: 'category', data: this.callTrend.labels,
					axisLine: { lineStyle: { color: '#2a5a9a' } },
					axisLabel: { color: '#7fa8d9', fontSize: 10 }
				},
				yAxis: {
					type: 'value', axisLine: { show: false },
					splitLine: { lineStyle: { color: 'rgba(0,180,255,0.1)' } },
					axisLabel: { color: '#7fa8d9', fontSize: 10 }
				},
				series: [{
					type: 'line', smooth: true, symbol: 'none',
					data: this.callTrend.values,
					lineStyle: { color: '#00d4ff', width: 2 },
					areaStyle: {
						color: {
							type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
							colorStops: [
								{ offset: 0, color: 'rgba(0,212,255,0.4)' },
								{ offset: 1, color: 'rgba(0,212,255,0)' },
							]
						}
					}
				}]
			})
		},
		resizeCharts() {
			Object.keys(this.miniCharts).forEach(key => this.miniCharts[key] && this.miniCharts[key].resize())
			if (this.pieChartInst) this.pieChartInst.resize()
			if (this.trendChartInst) this.trendChartInst.resize()
			if (this.modalChartInst) this.modalChartInst.resize()
		},
		openModal(c) {
			// 先用卡片已有数据立即弹出，详情接口返回后整框替换
			this.current = {
				code: c.code,
				name: c.name,
				icon: c.icon,
				categoryName: this.catName(c.cat),
				version: c.version,
				statusText: this.statusText(c.status),
				description: c.desc,
				metrics: [
					{ label: '今日调用次数', value: c.calls, unit: '次' },
					{ label: '服务可用率', value: c.status === 'soon' ? null : c.avail, unit: '%' },
					{ label: '服务企业数', value: c.orgs, unit: '家' },
					{ label: '开放接口数', value: c.apiCount != null ? c.apiCount : (c.apis || []).length, unit: '个' },
				],
				trend: { labels: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'], values: c.trend || [] },
				apis: c.apis || [],
			}
			this.$nextTick(this.renderModalChart)
			if (c.code) this.fetchComponentDetail(c.code)
		},
		// 组件详情：code 取 overview 的 components[].code
		fetchComponentDetail(code) {
			this.$request2('/admin-api/statistics/brain/component/detail?code=' + encodeURIComponent(code)).then(res => {
				const value = res && res.code === 0 && res.data ? res.data.value : null
				if (!value || !this.current || this.current.code !== code) return
				const labels = this.parseList(value.trend && value.trend.labels)
				const values = this.parseList(value.trend && value.trend.values)
				this.current = {
					code: value.code,
					name: value.name,
					icon: value.icon,
					categoryName: value.categoryName,
					version: value.version,
					statusText: value.statusText || this.current.statusText,
					description: value.description || '',
					metrics: value.metrics || [],
					trend: {
						labels: labels.length ? labels : ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
						values: values,
					},
					// realPath 备用不上主列表，页面展示 displayPath
					apis: (value.apis || []).map(a => ({ m: a.method, p: a.displayPath, d: a.description })),
				}
				this.$nextTick(this.renderModalChart)
			}).catch(e => {
				console.warn('组件详情接口请求失败，展示卡片汇总数据', e)
			})
		},
		renderModalChart() {
			if (this.modalChartInst) {
				this.modalChartInst.dispose()
				this.modalChartInst = null
			}
			if (!this.current || !this.current.trend.values.length) return
			const el = this.$refs.modalChart
			if (!el) return
			let labels = this.current.trend.labels
			if (labels.length !== this.current.trend.values.length) {
				labels = this.current.trend.values.map((v, i) => '第' + (i + 1) + '天')
			}
			// 日期标签 yyyy-MM-dd 只显示 MM-dd
			labels = labels.map(l => (typeof l === 'string' && l.length > 7 ? l.slice(5) : l))
			this.modalChartInst = echarts.init(el)
			this.modalChartInst.setOption({
				grid: { left: 40, right: 20, top: 20, bottom: 30 },
				tooltip: { trigger: 'axis' },
				xAxis: {
					type: 'category', data: labels,
					axisLine: { lineStyle: { color: '#2a5a9a' } },
					axisLabel: { color: '#7fa8d9' }
				},
				yAxis: {
					type: 'value',
					splitLine: { lineStyle: { color: 'rgba(0,180,255,0.1)' } },
					axisLabel: { color: '#7fa8d9' }
				},
				series: [{
					type: 'bar', data: this.current.trend.values, barWidth: '40%',
					itemStyle: {
						color: {
							type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
							colorStops: [
								{ offset: 0, color: '#00d4ff' },
								{ offset: 1, color: '#165DFF' },
							]
						}
					}
				}]
			})
		},
		closeModal() {
			if (this.modalChartInst) {
				this.modalChartInst.dispose()
				this.modalChartInst = null
			}
			this.current = null
		}
	}
}
</script>

<style scoped lang="scss">
	.component-overview {
		position: absolute;
		top: 72px;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 8;
		overflow-y: auto;
		padding-bottom: 20px;

		/* ===== 标题区 ===== */
		.hero {
			position: relative;
			text-align: center;
			padding: 28px 20px 18px;

			.back-btn {
				position: absolute;
				left: 28px;
				top: 18px;
				transform: none;
				padding: 6px 16px;
				font-size: 14px;
				line-height: 1;
				cursor: pointer;
				color: #00e5ff;
				background: rgba(0, 180, 255, 0.12);
				border: 1px solid rgba(0, 212, 255, 0.6);
				border-radius: 4px;
				transition: all .2s;

				&:hover {
					background: rgba(0, 180, 255, 0.24);
					box-shadow: 0 0 10px rgba(0, 180, 255, 0.35);
					color: #fff;
				}
			}

			h1 {
				font-size: 36px;
				font-weight: 800;
				letter-spacing: 6px;
				background: linear-gradient(180deg, #ffffff 30%, #6fd6ff 100%);
				-webkit-background-clip: text;
				background-clip: text;
				-webkit-text-fill-color: transparent;
				text-shadow: 0 0 40px rgba(0, 212, 255, 0.4);
			}

			.sub {
				margin-top: 8px;
				color: #7fa8d9;
				font-size: 13px;
				letter-spacing: 3px;
			}

			.deco {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 12px;
				margin-top: 14px;

				.line {
					width: 120px;
					height: 1px;
					background: linear-gradient(90deg, transparent, #00d4ff);
				}

				.line.r {
					background: linear-gradient(90deg, #00d4ff, transparent);
				}

				.diamond {
					width: 8px;
					height: 8px;
					background: #00e5ff;
					transform: rotate(45deg);
					box-shadow: 0 0 8px #00e5ff;
				}
			}
		}

		/* ===== 统计概览条 ===== */
		.stats-bar {
			position: relative;
			display: grid;
			grid-template-columns: repeat(6, 1fr);
			gap: 16px;
			padding: 0 28px;
			margin-top: 10px;
		}

		.stat-item {
			position: relative;
			background: rgba(13, 42, 89, 0.55);
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-radius: 6px;
			padding: 16px 18px;
			overflow: hidden;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 3px;
				height: 100%;
				background: linear-gradient(180deg, #00d4ff, transparent);
			}

			.icon {
				position: absolute;
				right: 14px;
				top: 50%;
				transform: translateY(-50%);
				width: 42px;
				height: 42px;
				border-radius: 8px;
				background: rgba(0, 180, 255, 0.1);
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 20px;
				color: #00e5ff;
				border: 1px solid rgba(0, 180, 255, 0.25);
			}

			.num {
				font-size: 28px;
				font-weight: 700;
				color: #fff;
				line-height: 1.1;
				font-family: "DIN Alternate", "Helvetica Neue", sans-serif;

				.unit {
					font-size: 13px;
					color: #7fa8d9;
					margin-left: 4px;
					font-weight: 400;
				}
			}

			.label {
				font-size: 12px;
				color: #7fa8d9;
				margin-top: 6px;
				letter-spacing: 1px;
			}

			.trend {
				font-size: 11px;
				margin-top: 4px;
				color: #00ff9d;
			}
		}

		/* ===== 主容器 ===== */
		.main {
			position: relative;
			display: grid;
			grid-template-columns: 1fr 320px;
			gap: 16px;
			padding: 16px 28px 30px;
			align-items: start;
		}

		.toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 14px;
			flex-wrap: wrap;
			gap: 10px;
		}

		.filter-tabs {
			display: flex;
			gap: 8px;
			flex-wrap: wrap;
		}

		.ftab {
			padding: 6px 14px;
			font-size: 13px;
			cursor: pointer;
			background: rgba(22, 93, 255, 0.1);
			border: 1px solid rgba(0, 180, 255, 0.25);
			color: #7fa8d9;
			border-radius: 4px;
			transition: all .2s;

			&:hover {
				color: #e6f4ff;
				border-color: rgba(0, 212, 255, 0.6);
			}

			&.active {
				background: linear-gradient(180deg, #165DFF, #0d3aa8);
				color: #fff;
				border-color: rgba(0, 212, 255, 0.6);
				box-shadow: 0 0 10px rgba(0, 180, 255, 0.3);
			}
		}

		.search-box {
			position: relative;

			input {
				background: rgba(6, 20, 50, 0.7);
				border: 1px solid rgba(0, 180, 255, 0.25);
				color: #e6f4ff;
				padding: 7px 12px 7px 34px;
				border-radius: 4px;
				width: 240px;
				font-size: 13px;
				outline: none;

				&:focus {
					border-color: #00d4ff;
				}

				&::placeholder {
					color: #4a7bb0;
				}
			}

			.sicon {
				position: absolute;
				left: 10px;
				top: 50%;
				transform: translateY(-50%);
				color: #4a7bb0;
				font-size: 13px;
			}
		}

		/* ===== 组件卡片网格 ===== */
		.grid {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			gap: 14px;
		}

		.grid-empty {
			text-align: center;
			padding: 60px;
			color: #4a7bb0;
		}

		.card {
			position: relative;
			background: rgba(13, 42, 89, 0.55);
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-radius: 6px;
			padding: 16px;
			cursor: pointer;
			transition: all .25s;
			overflow: hidden;

			&::after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				height: 1px;
				background: linear-gradient(90deg, transparent, #00d4ff, transparent);
				opacity: 0;
				transition: opacity .25s;
			}

			&:hover {
				background: rgba(20, 60, 120, 0.7);
				border-color: rgba(0, 212, 255, 0.6);
				transform: translateY(-2px);
				box-shadow: 0 8px 24px rgba(0, 100, 255, 0.2);
			}

			&:hover::after {
				opacity: 1;
			}

			.head {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				margin-bottom: 10px;
			}

			.cicon {
				width: 44px;
				height: 44px;
				border-radius: 8px;
				background: linear-gradient(135deg, rgba(0, 180, 255, 0.2), rgba(22, 93, 255, 0.1));
				border: 1px solid rgba(0, 212, 255, 0.6);
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 20px;
				color: #00e5ff;
				box-shadow: inset 0 0 12px rgba(0, 180, 255, 0.15);
			}

			h3 {
				font-size: 15px;
				color: #fff;
				font-weight: 600;
				margin-bottom: 4px;
			}

			.desc {
				font-size: 12px;
				color: #7fa8d9;
				line-height: 1.5;
				min-height: 36px;
			}

			.metrics {
				display: flex;
				justify-content: space-between;
				margin-top: 12px;
				padding-top: 10px;
				border-top: 1px dashed rgba(0, 180, 255, 0.15);
			}

			.m {
				text-align: left;

				.v {
					font-size: 16px;
					font-weight: 700;
					color: #00e5ff;
					font-family: "DIN Alternate", sans-serif;

					&.green {
						color: #00ff9d;
					}
				}

				.l {
					font-size: 11px;
					color: #4a7bb0;
					margin-top: 2px;
				}
			}

			.mini-chart {
				height: 36px;
				margin-top: 8px;
			}
		}

		.status-tag {
			padding: 2px 8px;
			font-size: 11px;
			border-radius: 3px;
			font-weight: 500;

			&.running {
				background: rgba(0, 255, 157, 0.12);
				color: #00ff9d;
				border: 1px solid rgba(0, 255, 157, 0.3);
			}

			&.gray {
				background: rgba(255, 176, 32, 0.12);
				color: #ffb020;
				border: 1px solid rgba(255, 176, 32, 0.3);
			}

			&.soon {
				background: rgba(120, 140, 180, 0.12);
				color: #7fa8d9;
				border: 1px solid rgba(120, 140, 180, 0.3);
			}
		}

		/* ===== 右侧栏 ===== */
		.side {
			display: flex;
			flex-direction: column;
			gap: 16px;
		}

		.panel {
			background: rgba(13, 42, 89, 0.55);
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-radius: 6px;
			padding: 16px;
		}

		.panel-title {
			font-size: 14px;
			font-weight: 600;
			color: #fff;
			margin-bottom: 12px;
			padding-left: 10px;
			border-left: 3px solid #00d4ff;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.more {
				font-size: 11px;
				color: #4a7bb0;
				font-weight: 400;
				cursor: pointer;

				&:hover {
					color: #00e5ff;
				}
			}
		}

		.rank-list {
			list-style: none;

			li {
				display: flex;
				align-items: center;
				gap: 10px;
				padding: 8px 0;
				border-bottom: 1px dashed rgba(0, 180, 255, 0.1);
				font-size: 12px;
			}

			li:last-child {
				border-bottom: none;
			}
		}

		.rank-num {
			width: 18px;
			height: 18px;
			border-radius: 3px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 11px;
			font-weight: 700;
			flex-shrink: 0;

			&.r1 {
				background: rgba(255, 176, 32, 0.2);
				color: #ffb020;
			}

			&.r2 {
				background: rgba(180, 200, 230, 0.2);
				color: #c0d0e8;
			}

			&.r3 {
				background: rgba(205, 127, 50, 0.2);
				color: #d4956a;
			}

			&.rx {
				background: rgba(120, 140, 180, 0.15);
				color: #7fa8d9;
			}
		}

		.rank-name {
			flex: 1;
			color: #e6f4ff;
		}

		.rank-val {
			color: #00e5ff;
			font-weight: 600;
			font-family: "DIN Alternate", sans-serif;
            margin-right:30px;
		}

		.pie-chart {
			height: 200px;
		}

		.trend-chart {
			height: 180px;
		}

		/* ===== 模态框 ===== */
		.modal-mask {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.7);
			z-index: 1000;
			display: flex;
			align-items: center;
			justify-content: center;
			backdrop-filter: blur(4px);
		}

		.modal {
			width: 860px;
			max-width: 92vw;
			max-height: 88vh;
			overflow-y: auto;
			background: linear-gradient(180deg, #0d2b5c, #081a3a);
			border: 1px solid rgba(0, 212, 255, 0.6);
			border-radius: 8px;
			padding: 24px;
			box-shadow: 0 0 40px rgba(0, 180, 255, 0.3);
		}

		/* ===== 完整排行弹窗 ===== */
		.rank-modal {
			width: 520px;

			.modal-head h2 {
				font-size: 18px;
			}
		}

		.rank-full {
			max-height: 60vh;
			overflow-y: auto;

			.rank-empty {
				justify-content: center;
				color: #4a7bb0;
			}
		}

		.modal-head {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			margin-bottom: 18px;

			.left {
				display: flex;
				gap: 14px;
				align-items: center;
			}

			.cicon {
				width: 56px;
				height: 56px;
				border-radius: 10px;
				background: linear-gradient(135deg, rgba(0, 180, 255, 0.25), rgba(22, 93, 255, 0.15));
				border: 1px solid rgba(0, 212, 255, 0.6);
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 26px;
				color: #00e5ff;
			}

			h2 {
				font-size: 20px;
				color: #fff;
			}

			.cat {
				font-size: 12px;
				color: #7fa8d9;
				margin-top: 4px;
			}
		}

		.modal-close {
			width: 32px;
			height: 32px;
			border-radius: 4px;
			cursor: pointer;
			background: rgba(255, 255, 255, 0.05);
			border: 1px solid rgba(0, 180, 255, 0.25);
			color: #7fa8d9;
			display: flex;
			align-items: center;
			justify-content: center;

			&:hover {
				color: #fff;
				border-color: rgba(0, 212, 255, 0.6);
			}
		}

		.modal-desc {
			font-size: 13px;
			color: #7fa8d9;
			line-height: 1.7;
			padding: 12px;
			background: rgba(0, 0, 0, 0.2);
			border-radius: 4px;
			border-left: 3px solid #00d4ff;
			margin-bottom: 18px;
		}

		.modal-grid {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			gap: 12px;
			margin-bottom: 18px;
		}

		.mstat {
			background: rgba(0, 0, 0, 0.2);
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-radius: 4px;
			padding: 12px;
			text-align: center;

			.v {
				font-size: 22px;
				font-weight: 700;
				color: #00e5ff;
				font-family: "DIN Alternate", sans-serif;
			}

			.l {
				font-size: 11px;
				color: #7fa8d9;
				margin-top: 4px;
			}
		}

		.modal-section {
			margin-bottom: 18px;

			h4 {
				font-size: 14px;
				color: #fff;
				margin-bottom: 10px;
				padding-left: 8px;
				border-left: 3px solid #00d4ff;
			}
		}

		.modal-chart {
			height: 220px;
		}

		.api-table {
			width: 100%;
			border-collapse: collapse;
			font-size: 12px;

			th,
			td {
				padding: 8px 10px;
				text-align: left;
				border-bottom: 1px solid rgba(0, 180, 255, 0.1);
			}

			th {
				color: #7fa8d9;
				font-weight: 500;
				background: rgba(0, 0, 0, 0.2);
			}

			td {
				color: #e6f4ff;
			}

			.api-path {
				font-family: monospace;
				color: #00e5ff;
			}

			.method {
				display: inline-block;
				padding: 1px 6px;
				border-radius: 3px;
				font-size: 10px;
				font-weight: 700;
			}
		}

		.method.GET {
			background: rgba(0, 255, 157, 0.15);
			color: #00ff9d;
		}

		.method.POST {
			background: rgba(0, 180, 255, 0.15);
			color: #00e5ff;
		}

		.method.PUT {
			background: rgba(255, 176, 32, 0.15);
			color: #ffb020;
		}

		/* ===== Toast ===== */
		.page-toast {
			position: fixed;
			top: 140px;
			left: 50%;
			transform: translateX(-50%);
			background: rgba(13, 42, 89, 0.95);
			border: 1px solid rgba(0, 212, 255, 0.6);
			color: #fff;
			padding: 10px 20px;
			border-radius: 4px;
			font-size: 13px;
			z-index: 1100;
			opacity: 0;
			transition: opacity .25s;
			box-shadow: 0 4px 20px rgba(0, 180, 255, 0.3);
			pointer-events: none;

			&.show {
				opacity: 1;
			}
		}
	}
</style>
